function isNotUnderMyControl (message) {
  const callToActionTypeCode = message.callToActionTypeCode
  return callToActionTypeCode === 'wait_until_cm24_operator_has_reviewed_your_account_submisssion' ||
    callToActionTypeCode === 'wait_until_cm24_operator_has_reviewed_ad_submisssion' ||
    callToActionTypeCode === 'user_waiting_for_owner_to_answer_question' ||
    callToActionTypeCode === 'read_me' ||
    callToActionTypeCode === 'accept_offer_from_highest_bidder__sent' ||
    callToActionTypeCode === 'highest_bidder_waiting_for_owner_to_accept_offer_or_send_counteroffer_or_decline' ||
    callToActionTypeCode === 'merchant_waiting_for_owner_to_accept_late_offer_or_send_counteroffer_or_decline' ||
    callToActionTypeCode === 'owner_waiting_for_buyer_to_accept_counteroffer'
}

function isIgnoredCTA (message) {
  const callToActionTypeCode = message.callToActionTypeCode
  return callToActionTypeCode === 'bid_again_or_decline_or_submit_reminder' ||
    callToActionTypeCode === 'buyer_pay_provision_to_cm24' ||
    callToActionTypeCode === 'submit_ad_with_reduced_price_or_decline_to_submit_again' ||
    callToActionTypeCode === 'owner_waiting_for_buyer_to_pick_up_vehicle'
}

function isIgnoredReadMe (message) {
  const subject = message.subject
  return subject.includes('Ihr Gebot ist eingegangen') || subject.includes('Ihr Bietagent ist jetzt aktiv')
}

function hasOpenCta (message) {
  const ignore = isNotUnderMyControl(message) || isIgnoredCTA(message)
  return !ignore
}

function computeOpenReadMes (messages) {
  return messages
    .filter(m => m.messageId)
    .filter(m => !isIgnoredReadMe(m))
    .filter(message => message.read === false).length
}

const tasks = {
  isNotUnderMyControl,
  isIgnoredCTA,
  hasOpenCta,
  computeOpenReadMes
}

export default tasks
